<script lang="ts">
  import LayoutGrid, { Cell } from '@smui/layout-grid';
  import { marked } from 'marked';
  import { getAppConfig } from '../../../../common/config/app-config';
  import HorizontalDivider from '../../../common/components/HorizontalDivider.svelte';
  import PictureTag from '../../../common/lazy-components/PictureTag.svelte';
  import { getBlogImageAltTextFromUrl } from '../../services/blog-data-services';

  export let data;
  const { lang } = getAppConfig();
</script>

<section class="blog-mobile-variant-section">
  <LayoutGrid>
    <Cell class="blog-detail-mobile-text-container" spanDevices={{ phone: 4 }}>
      <div class="blog-detail-mobile-text">
        {#if data?.title}
          <div class="blog-detail-mobile-title-container">
            <h5 class="blog-detail-mobile-title">
              {data?.title}
            </h5>
          </div>
        {/if}
      </div>
    </Cell>
    <Cell class="blog-mobile-image-container" spanDevices={{ phone: 4 }}>
      <div class="blog-detail-mobile-image {data?.designType === 'Right' ? 'right-image' : 'left-image'}">
        <PictureTag image={data?.image} alt={getBlogImageAltTextFromUrl(data?.image)} width="100%" />
      </div>
    </Cell>
    <Cell class="blog-mobile-description-container" spanDevices={{ phone: 4 }}>
      <div class="blog-detail-mobile-description-container">
        {#if data?.descriptionAr || data?.descriptionEn}
          <p class="blog-detail-mobile-description">
            {@html lang === 'en' ? marked(`${data?.descriptionEn}`) : marked(`${data?.descriptionAr}`)}
          </p>
        {/if}
      </div>
    </Cell>
  </LayoutGrid>
</section>
{#if data?.divider}
  <HorizontalDivider height="1" />
{/if}

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';
  .blog-mobile-variant-section {
    :global {
      .mdc-layout-grid {
        padding: 0;
      }
    }
    .blog-detail-mobile-text {
      .blog-detail-mobile-title {
        font-size: 16px;
        line-height: 20px;
        font-weight: 700;
        color: $neutral-dark-01;
        margin: 0;
      }
    }
    .blog-detail-mobile-description {
      margin: 0;
      :global {
        p {
          font-size: 14px;
          font-weight: 400;
          line-height: 16px;
          color: $neutral-dark-01;
          margin: 0;
          a {
            text-decoration: underline;
          }
        }
      }
    }
    .right-image {
      :global(img) {
        border-radius: 0px 12px 12px 0px;
      }
    }
    .left-image {
      :global(img) {
        border-radius: 12px 0px 0px 12px;
      }
    }
  }
</style>
